/**
 * @file automatically generated from MApp.Data.AttachmentType
 */

export enum AttachmentType {
    Javascript = 1,
    Html = 2,
    Css = 3
}
